import React, { Suspense } from "react";
import type { validateCCFieldOnBlur } from "actions/credit_cards";
import type { updateNewCreditCard } from "actions/online_ordering/checkout";
import Loader from "components/loader";
import { useCCProcessorConfiguration } from "hooks/online_ordering/payment/useCCProcessorConfiguration";
import type { INewCreditCard } from "types/reducers/payment";

export interface CreditCardInputsProps {
  newCreditCard: INewCreditCard;
  onNewCreditCardUpdate: typeof updateNewCreditCard;
  onBlurValidateField: typeof validateCCFieldOnBlur;
}

export const CreditCardInputs = (props: CreditCardInputsProps) => {
  const ccProcessorConfiguration = useCCProcessorConfiguration();
  const CreditCardInputImplementation = ccProcessorConfiguration?.ccInput;

  if (!CreditCardInputImplementation) {
    return null;
  }

  return (
    <Suspense fallback={<Loader />}>
      <CreditCardInputImplementation {...props} />
    </Suspense>
  );
};
